import clsx from 'clsx'

const SkeletonImage = () => {
  return (
    <div class="relative w-full aspect-1/1 bg-page-secondary overflow-hidden animate-pulse">
    </div>
  )
}

const SkeletonDetails = () => {
  return (
    <>
      <div className={'col-[1/2] w-full h-1.125 bg-page-secondary animate-pulse'}></div>
      <div className={'xl:col-[2/3] xl:row-[1/3] w-full h-1.125 bg-page-secondary animate-pulse'}></div>
    </>
  )
}

export const SkeletonCard = ({ className }) => {
  return (
    <div class={clsx('flex flex-col w-full grow', className)}>
        <SkeletonImage />
        <div className='grow grid xl:grid-cols-full-min auto-rows-min flex-col gap-x-1 gap-y-0.25 px-0.625 lg:px-1 py-1'>
          <SkeletonDetails />
          <div className="col-[1/2] flex xl-max:flex-col xl:items-center flex-wrap gap-x-0.25 gap-y-0.5 xl-max:mt-0.25">
            <div className="w-[70px] h-1.125 bg-page-secondary animate-pulse"></div>
            <div className="w-[70px] h-1.125 bg-page-secondary animate-pulse"></div>
          </div>
        </div>
    </div>
  )
}
